import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

/**
 * Composable for soft-deleting a draft lead (admin)
 */
export function useDeleteDraftLead() {
    const api = useApi();
    const toaster = useToaster();
    const queryClient = useQueryClient();

    const { mutate, mutateAsync, isPending, error, reset } = useMutation({
        mutationFn: (id: number) => {
            return api.admin.draftLeads.deleteDraftLead({
                params: { id },
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["admin", "draft-leads"] });
            toaster.create({
                title: "Draft lead deleted successfully",
                type: "success",
            });
        },
        onError: (error) => {
            toaster.create({
                title: "Failed to delete draft lead",
                description: error.message || "An error occurred",
                type: "error",
            });
            console.error("[useDeleteDraftLead] Error:", error);
        },
    });

    return {
        mutate,
        mutateAsync,
        isPending,
        error,
        reset,
    };
}
